/** @format */

export const pdpJsonFileName = {
	bannedWords: 'banned-words-091019.json',
	brandsData: 'brands-data-09152021.json',
	categoriesData: 'categories-data-11102021.json',
	ecodesData: 'ecodes-data-04102020.json',
	shippingMessages: 'shipping-messages-01292025.json',
	exclusiveContent: 'exclusive-content.json'
};
